import { CSV_REPORT_TYPES } from '@/api/rest/resources/types/reports';
import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useWidgetSlotConfigurationByNameType } from '@/hooks/useWidgetConfigurationByOrganizationId';
import { CsvExportButton } from '@/pages/shared/reports/components/CsvExportButton';

import { useDefaultCustomCells, useOrderedCustomCells, useWaterCells } from '../plots/hooks/useGetCustomCells';
import { ProjectTypeAccessorKey } from '../projects/pages/project/pages/sustainableProduction/components/plot-list/constants';
import { LandPageLayout } from './components/LandPageLayout';

export const LandWaterPage = () => {
  const widgetSlotsConfiguration = useWidgetSlotConfigurationByNameType(
    DefaultWidgetNames.default_template_asset_water,
    WidgetType.t_page,
  );

  const defaultCells = [...useDefaultCustomCells(), ...useWaterCells()];
  const orderedCustomCells = useOrderedCustomCells(defaultCells, [
    ProjectTypeAccessorKey.waterHoldingCapacityTrend_1y,
    ProjectTypeAccessorKey.waterHoldingCapacity,
  ]);

  return (
    <LandPageLayout
      navBarProps={{
        children: <CsvExportButton reportType={CSV_REPORT_TYPES.WATER_CSV} className='w-fit font-normal' />,
      }}
      plotListProps={{
        customColumns: orderedCustomCells,
      }}
    >
      <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
    </LandPageLayout>
  );
};
